import Card from "react-bootstrap/Card";
import { purchase_Profile_Static_Info } from "@/setting";
import WinningBidDepositInfo from "./WinningBidDepositInfo";

function StaticInfo({ data, paymentFlag }) {
  const cmsData = data;
  // console.log("dhdhdh", cmsData);
  return (
    <Card body className="mb-4 Static_Info">
      {paymentFlag && (
        <>
          <WinningBidDepositInfo />
        </>
      )}
      <p style={{ fontSize: "15px" }}>
        {" "}
        {cmsData?.purchase_Profile_Static_Info || purchase_Profile_Static_Info}
      </p>
    </Card>
  );
}

export default StaticInfo;
